module.exports = __webpack_public_path__ + "img/import_kfflow_picture@3x.d25786ad.png";